import {
  getRefreshHandlerState,
  setRefreshHandlerState,
} from './authStoreState.js'
import { setAccessToken } from './authStoreToken.js'

export function setRefreshHandler(fn) {
  setRefreshHandlerState(fn)
}

export async function runRefreshHandler() {
  const refreshHandler = getRefreshHandlerState()
  if (typeof refreshHandler !== 'function') return null
  try {
    const next = await refreshHandler()
    setAccessToken(next ?? null)
    return next ?? null
  } catch {
    setAccessToken(null)
    return null
  }
}
